export type PrefillKey = (typeof PREFILL_KEYS)[number]
export const PREFILL_KEYS = ['purchase_price', 'monthly_salary', 'tax_class'] as const
